import * as React from "react";
import DataSource, { DATE_DISPLAY_FORMAT } from "../lib/DataSource";
import { Breadcrumb, Col, Row, Space } from "antd";
import "../css/student.css";
import FieldsViewBlock from "../lib/FieldsViewBlock";
import Moment from "moment";
import { Link } from "react-router-dom";
import {
  BackwardFilled,
  BackwardOutlined,
  CloseCircleOutlined,
  EditFilled,
} from "@ant-design/icons";

export default class StudentView extends React.Component<
  { id: number },
  { data: any; fields: any; definition: any; agencyList: any; courselist: any }
> {
  contentType = "student";

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      fields: null,
      definition: null,
      agencyList: [],
      courselist: [],
    };
  }

  componentDidMount() {
    DataSource.loadFields(this.contentType).then((def) => {
      this.setState({ fields: def.fields, definition: def.definition });
    });
    DataSource.loadData(this.contentType, this.props.id).then((data) => {
      this.setState({ data: data });
    });
    DataSource.loadList("course", "", 0, 100).then((data) => {
      this.setState({ courselist: data.list });
    });
    DataSource.loadList("agency", "", 0, 100).then((data) => {
      this.setState({ agencyList: data.list });
    });
  }

  formatField(field, value) {
    switch (field) {
      case "birthdate":
      case "starting_date":
        return Moment(value).format(DATE_DISPLAY_FORMAT);
        break;

      default:
        return value;
    }
  }

  render() {
    if (
      !this.state.data ||
      !this.state.fields ||
      !this.state.definition ||
      this.state.agencyList.length == 0 ||
      this.state.courselist.length == 0
    ) {
      return <div className="loading"></div>;
    }

    let fields = this.state.fields;
    let definition = this.state.definition;
    let data = this.state.data;
    let course = this.state.courselist.find((item) => item.id == data.course);
    let agency = this.state.agencyList.find((item) => item.id == data.agency);

    return (
      <div id={"view-" + this.contentType}>
        <h2>View {definition.name}</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/student/list">Student list</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{this.props.id}</Breadcrumb.Item>
        </Breadcrumb>

        <div id="content-detail">
          <FieldsViewBlock
            blockName="Base Information"
            viewFields={[
              "firstname",
              "lastname",
              "student_no",
              "sex",
              "birthdate",
              "nationality",
              "telephone",
              "email",
            ]}
            fields={fields}
            data={data}
            formatter={this.formatField}
          />

          <FieldsViewBlock
            blockName="Address Information"
            viewFields={["address1", "address2", "address3", "address4"]}
            fields={fields}
            data={data}
            formatter={this.formatField}
          />

          <FieldsViewBlock
            blockName="Study Information"
            viewFields={["stage", "intake", "entry_year"]}
            fields={fields}
            data={data}
            formatter={this.formatField}
          />

          <Row>
            <Col span={4} className="field-key-col">
              Course:
            </Col>
            <Col span={8}>{course.name}</Col>
          </Row>

          <Row>
            <Col span={4} className="field-key-col">
              Agency:
            </Col>
            <Col span={8}>{agency ? agency.name : ""}</Col>
          </Row>

          <FieldsViewBlock
            blockName="Notes"
            viewFields={["status", "note"]}
            fields={fields}
            data={data}
            formatter={this.formatField}
          />
        </div>

        <div style={{ textAlign: "center" }}>
          <br />
          <br />
          <Space>
            <Link to={"/student/edit/" + this.props.id}>
              <EditFilled /> Edit
            </Link>
            <Link to={"/student/list"}>
              <CloseCircleOutlined /> Back
            </Link>
          </Space>
        </div>
      </div>
    );
  }
}
